import type { Board } from '@trello/model-types';

export const getMembershipForBoard = <
  InputBoard extends {
    memberships?: Pick<Board['memberships'][number], 'idMember'>[] | null;
  }
>(
  board: InputBoard,
  memberId: string,
): NonNullable<InputBoard['memberships']>[number] | undefined => {
  // There are cases where `memberships` are returning null
  // and are not caught by typescript
  // TODO investigate how board.memberships can be null and why
  // typescript is not catching these errors
  if (!board.memberships) {
    return;
  }

  return board.memberships.find(
    (membership) => membership.idMember === memberId,
  );
};
